import React from 'react'
import './src/gatsby/fragments'
import './src/styles/global-html-classes.scss'
import { CacheProvider } from '@emotion/react'
import createEmotionCache from './src/utils/create-emotion-cache'
import WrapRootElement from './src/wrap-root-element'
import WrapPageElement from './src/wrap-page-element'
import { applySeoForPath } from './src/utils/seo-browser'

const clientCache = createEmotionCache()

export const wrapRootElement = ({ element }) => (
  <CacheProvider value={clientCache}>
    <WrapRootElement element={element} emotionCache={clientCache} />
  </CacheProvider>
)

export const wrapPageElement = ({ element, props }) => (
  <WrapPageElement element={element} props={props} />
)

export const onRouteUpdate = async ({ location }) => {
  try { await applySeoForPath(location.pathname, 'Harbor Capital') } catch (e) {
    // Error intentionally ignored
  }
}

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  if (location.hash) return false
  window.history.scrollRestoration = 'manual'
  const saved = getSavedScrollPosition(location, location.key)
  if (!saved) return false
  const [x, y] = saved
  const restore = () => requestAnimationFrame(() => window.scrollTo(x, y))
  restore()
  setTimeout(restore, 25)
  return false
}
